export default {
  tabs: {
    gift_cards: 'Lahjakortit',
    settings: 'Asetukset',
  },
  gift_cards: {
    title: 'Lahjakortit',
    subtitle: 'Hallinnoi ravintolasi kaikkia lahjakortteja',
    buttons: {
      create: 'Luo lahjakortti',
      redeem: 'Lunasta lahjakortti',
      check_balance: 'Tarkista saldo',
    },
    search: {
      placeholder: 'Syötä hakuteksti',
    },
    columns: {
      code: 'Koodi',
      status: 'Tila',
      balance: 'Saldo',
      value: 'Arvo',
      email: 'Ostaja',
      source: 'Lähde',
      created_at: 'Luotu',
    },
    statuses: {
      active: 'Aktiivinen',
      partially_redeemed: 'Osittain lunastettu',
      redeemed: 'Lunastettu',
    },
  },
  settings: {
    gift_cards_availability: {
      title: 'Lahjakortin asetukset',
      subtitle: 'Määritä ravintolasi lahjakorttiasetukset',
      availability: {
        title: 'Ota lahjakortit käyttöön',
        subtitle: 'Salli asiakkaiden ostaa ja lunastaa lahjakortteja',
        buttons: {
          enable: 'Ota käyttöön',
          disable: 'Poista käytöstä',
        },
      },
    },
    redemption_options: {
      title: 'Lunastusvaihtoehdot',
      subtitle: 'Valitse, missä asiakkaat voivat lunastaa lahjakortteja',
      redemption_mode: {
        title: 'Lunastustila',
        subtitle: 'Tämä vaikuttaa lahjakorttisivusi tekstiin',
        buttons: {
          online: 'Vain verkossa',
          online_and_store: 'Verkossa ja ravintolassa',
        },
      },
    },
  },
  summary: {
    total_value: 'Kokonaisarvo',
    total_active: 'Aktiivisia yhteensä',
    redeemed_this_month: 'Lunastettu tässä kuussa',
  },
};
